import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";

const initPhotoSwipe = () => {
  // Only initialize on product pages with media gallery
  const mediaGallery = document.querySelector("#media-gallery");
  if (!mediaGallery || window.productGalleryLightbox) {
    return;
  }

  try {
    // Check and handle duplicate images before initializing
    removeDuplicateZoomImages();

    window.productGalleryLightbox = new PhotoSwipeLightbox({
      gallery: "#media-gallery",
      children: "a.zoom-image",
      pswpModule: PhotoSwipe,
      showHideAnimationType: "fade",
      preloaderDelay: 2000,
      arrowPrevSVG: `<svg viewBox="0 0 6 7" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 6.07143L1.65816 3.5L0 0.928572L6 3.5L0 6.07143Z" fill="#ffffff"/>
    </svg>`,
      arrowNextSVG: `<svg viewBox="0 0 6 7" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 6.07143L1.65816 3.5L0 0.928572L6 3.5L0 6.07143Z" fill="#ffffff"/>
    </svg>`,
    });

    window.productGalleryLightbox.init();
  } catch (error) {
    console.error("PhotoSwipe initialization error:", error);
  }
};

/**
 * Removes duplicate zoom images from the gallery by checking image sources
 * This ensures PhotoSwipe doesn't show the same image multiple times
 */
const removeDuplicateZoomImages = () => {
  const gallery = document.querySelector("#media-gallery");
  if (!gallery) return;

  const zoomLinks = gallery.querySelectorAll("a.zoom-image");
  const seenUrls = new Set();
  let duplicatesFound = false;

  zoomLinks.forEach((link) => {
    const imgSrc = link.getAttribute("href");
    if (seenUrls.has(imgSrc)) {
      // This is a duplicate image, remove it from the DOM
      link.classList.remove("zoom-image");
      console.warn("Duplicate zoom image removed:", imgSrc);
      duplicatesFound = true;
    } else {
      seenUrls.add(imgSrc);
    }
  });

  if (duplicatesFound) {
    console.info("Duplicate zoom images were detected and filtered out");
  }
};

// Wait for both DOM and Splide to be ready
const initWhenReady = () => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      // Small delay to ensure Splide is initialized first
      setTimeout(initPhotoSwipe, 100);
    });
  } else {
    setTimeout(initPhotoSwipe, 100);
  }
};

initWhenReady();
